import { useState } from 'react'
import { Link } from 'react-router-dom'
import apiClient from '../api/client'

function ForgotPasswordPage(): JSX.Element {
  const [email, setEmail] = useState('')
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await apiClient.post('/auth/forgot-password', { email })
      setDone(true)
    } catch (err: unknown) {
      let msg = 'Request failed'
      const maybeAxios = err as { response?: { data?: { detail?: string } }; message?: string }
      if (maybeAxios?.response?.data?.detail) msg = maybeAxios.response.data.detail
      else if (maybeAxios?.message) msg = maybeAxios.message
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">BibPipeline</h1>
        <p className="login-subtitle">Reset your password</p>
        {done ? (
          <p style={{ fontSize: 14 }}>
            If an account exists for this email, a reset link has been sent. Check your inbox.
          </p>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <label className="login-label">
              Email
              <input
                type="email"
                className="login-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>
            {error && <p style={{ color: '#c00', fontSize: 14 }}>{error}</p>}
            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        )}
        <p style={{ marginTop: 16, fontSize: 14, textAlign: 'center' }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
